import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import IntersectionObserver from '@researchgate/react-intersection-observer';

import 'src/components/BoxPopularCities.scss';


const BoxPopularCities = ({
  imageUrl, title, counter, link
}) => {
  const titleCopy = `szukaj ofert pracy zdalnej: ${title}`;
  const counterCopy = `${counter} oferty`;
  const [sourceImageUrl, setSourceImageUrl] = useState('');
  const observerCallback = useCallback(({ isIntersecting }, unobserve) => requestIdleCallback(() => {
    if (isIntersecting) {
      setSourceImageUrl(imageUrl);
      unobserve();
    }
  }), [imageUrl]);
  const renderImg = () => (
    <figure styleName="box-popular__img-wrap">
      <img
        alt=""
        aria-hidden="true"
        src={ sourceImageUrl }
        styleName="box-img"
      />
    </figure>
  );

  return (
    <a data-test="seo-box-city-tile" href={ link } styleName="box-popular" title={ titleCopy }>
      <IntersectionObserver onChange={ observerCallback } rootMargin="100px">
        { renderImg() }
      </IntersectionObserver>
      <div styleName="box-popular__content-wrap box-content">
        <h4 styleName="box-content__title">{ title }</h4>
        <span styleName="box-content__counter">
          { counterCopy }
        </span>
      </div>
    </a>
  );
};

BoxPopularCities.propTypes = {
  counter: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default BoxPopularCities;
